import qs from 'qs';
import request from '../index';

// 上传文件
export const uploadProduceAttachment = (data) => request.post('api-qc/uploadProduceAttachment', data, {
    timeout: 1800000,
});

// 获得异常问题统计和处理列表
export const getAbnormalProblemHandleList = (params) => request.get('/api-qc/getAbnormalProblemHandleList', { params });

// 添加或更新异常问题统计和处理
export const saveOrUpdateAbnormalProblemHandle = (data) => request.post('/api-qc/saveOrUpdateAbnormalProblemHandle', data);

// 获得物料缺货情况列表
export const getMaterialShortageList = (params) => request.get('/api-qc/getMaterialShortageList', { params });

// 添加或更新物料缺货情况
export const saveOrUpdateMaterialShortage = (data) => request.post('/api-qc/saveOrUpdateMaterialShortage', data);

// 获得作业指导书及其记录表反馈列表
export const getWIRecordList = (params) => request.get('/api-qc/getWIRecordList', { params });

// 添加或更新作业指导书及其记录表反馈
export const saveOrUpdateWIRecord = (data) => request.post('/api-qc/saveOrUpdateWIRecord', data);

// 获得工位检查列表
export const getStationCheckList = (params) => request.get('/api-qc/getStationCheckList', { params });

// 添加或更新工位检查
export const saveOrUpdateStationCheck = (data) => request.post('/api-qc/saveOrUpdateStationCheck', data);

// 获得工艺变更列表
export const getProcessChangeList = (params) => request.get('/api-qc/getProcessChangeList', { params });

// 添加或更新工艺变更
export const saveOrUpdateProcessChange = (data) => request.post('/api-qc/saveOrUpdateProcessChange', data);

// 获得质量抽查列表
export const getQualitySpotCheckList = (params) => request.get('/api-qc/getQualitySpotCheckList', { params });

// 添加或更新质量抽查
export const saveOrUpdateQualitySpotCheck = (data) => request.post('/api-qc/saveOrUpdateQualitySpotCheck', data);

// 获得质量抽查列表
export const getCapacitySpotCheckList = (params) => request.get('/api-qc/getCapacitySpotCheckList', { params });

// 添加或更新质量抽查
export const saveOrUpdateCapacitySpotCheck = (data) => request.post('/api-qc/saveOrUpdateCapacitySpotCheck', data);

// 删除生产任务
export const deleteProductionTask = (data) => request.delete('/api-qc/deleteProductionTask', { data });

// 删除异常问题统计和处理
export const deleteAbnormalProblemHandle = (data) => request.delete('/api-qc/deleteAbnormalProblemHandle', { data });

// 删除产能抽查
export const deleteCapacitySpotCheck = (data) => request.delete('/api-qc/deleteCapacitySpotCheck', { data });

// 删除物料缺货情况
export const deleteMaterialShortage = (data) => request.delete('/api-qc/deleteMaterialShortage', { data });

// 删除工艺变更
export const deleteProcessChange = (data) => request.delete('/api-qc/deleteProcessChange', { data });

// 删除质量抽查
export const deleteQualitySpotCheck = (data) => request.delete('/api-qc/deleteQualitySpotCheck', { data });

// 删除工位检查
export const deleteStationCheck = (data) => request.delete('/api-qc/deleteStationCheck', { data });

// 删除作业指导书及其记录表反馈
export const deleteWIRecord = (data) => request.delete('/api-qc/deleteWIRecord', { data });

// 添加或更新生产任务计划
export const saveOrUpdateProductionTaskSchedule = (data) => request.post('/api-qc/saveOrUpdateProductionTaskSchedule', data);

// 更新生产任务表
export const saveOrUpdateProductionTask = (data) => request.post('/api-qc/saveOrUpdateProductionTask', data);

// 获得生产任务列表
export const getBatch = (params) => request.get('/api-qc/getBatch', { params });

// 获得生产任务列表
export const getProductionTaskScheduleList = (params) => request.get('/api-qc/getProductionTaskScheduleList', { params });

// 添加或更新返修任务
export const saveOrUpdateRepairTask = (data) => request.post('/api-qc/saveOrUpdateRepairTask', data);

// 获得返修任务列表
export const getRepairTaskList = (params) => request.get('/api-qc/getRepairTaskList', { params });

// 获得生产任务列表
export const getProductionTaskList = (params) => request.get('/api-qc/getProductionTaskList', { params });

// 获得计划半成品
export const getPlannedSemiFinishedProducts = (params) => request.get('/api-qc/getPlannedSemiFinishedProducts', { params });

// 获得返修半成品
export const getRepairSemiFinishedProducts = (params) => request.get('/api-qc/getRepairSemiFinishedProducts', { params });

// 获得当天半成品工序库存
export const getInventory = () => request.get('/api-qc/getInventory');
